import { cn } from '@commenda/utils';

import { EmptyStateV2 } from '../../../components/empty-state/EmptyStateV2';
import { IndirectTaxFilingsHelper } from '../helpers';
import { IIndirectTaxFilingReturnSummary } from '../types';

interface IndirectTaxFilingDetailReturnSummaryProps {
  summary: IIndirectTaxFilingReturnSummary;
  title?: string;
}

const IndirectTaxFilingDetailReturnSummary = ({
  summary,
  title = 'Return summary',
}: IndirectTaxFilingDetailReturnSummaryProps) => {
  const { sections, currency } = summary;
  const nonEmptySections = sections.filter(
    (section) => section.rows.length > 0
  );

  return (
    <div className="flex flex-col">
      <span className="txt-medium-bold text-text-primary mb-3xl">{title}</span>

      {nonEmptySections.length === 0 ? (
        <EmptyStateV2
          title="No filing data available"
          description="Return summary will appear here once filing contributions have been prepared."
        />
      ) : (
        <div className="flex flex-col">
          {nonEmptySections.map((section, index) => (
            <div
              key={section.title}
              className={cn(
                'flex flex-col',
                index > 0 && 'mt-3xl pt-3xl border-t border-border-primary'
              )}
            >
              <div className="flex items-center justify-between border-b pb-md mb-md">
                <span className="txt-extra-small-medium text-text-tertiary">
                  {section.title}
                </span>
                <span className="txt-extra-small-medium text-text-tertiary">
                  {currency ? `Amount (${currency})` : 'Amount'}
                </span>
              </div>

              <div className="flex flex-col gap-md">
                {section.rows.map((row) => (
                  <div
                    key={row.label}
                    className="flex items-center justify-between"
                  >
                    <span className="txt-small-regular text-text-secondary">
                      {row.label}
                    </span>
                    <span className="txt-small-medium text-text-primary">
                      {currency
                        ? IndirectTaxFilingsHelper.formatCurrency(
                            row.value ?? 0
                          )
                        : 'N/A'}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export { IndirectTaxFilingDetailReturnSummary };
